/**
 * @generated SignedSource<<89b886ed310298ecc2538e18bb6a8d6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkEventModal_stream$data = {
  readonly id: string;
  readonly linkedEvent: {
    readonly finalOccurrence: string | null;
    readonly guid: string;
    readonly id: string;
    readonly nextOccurrence: {
      readonly end: string | null;
      readonly start: string | null;
    } | null;
    readonly recurrenceRule: ReadonlyArray<string | null> | null;
    readonly title: string;
  } | null;
  readonly otherUser: {
    readonly fullName: string;
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useEventState_stream">;
  readonly " $fragmentType": "LinkEventModal_stream";
};
export type LinkEventModal_stream$key = {
  readonly " $data"?: LinkEventModal_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkEventModal_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkEventModal_stream",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useEventState_stream"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "otherUser",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "linkedEvent",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recurrenceRule",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "nextOccurrence",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finalOccurrence",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "dfb6b4d1e2ec99363702a6a86ed5705a";

export default node;
